import React, { Component } from 'react';
import purifyHTML from '../../../utils/purifyHTML';

export default class Wrapper extends Component {
  render() {
    const { submitError, submitErrorMessage, fieldErrors, fieldErrorsMessage } = this.props;

    return (
      <div className="form__error">
        {submitError ? (
          <React.Fragment>
            {submitErrorMessage || 'Er ging iets mis tijdens het verzenden van het formulier'}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {fieldErrorsMessage || 'De volgende velden zijn nog niet correct ingevuld:'}
            <ul>{fieldErrors.map(error => (error.field ? <li key={`${error.field.name}`} dangerouslySetInnerHTML={purifyHTML(error.field.label || '')} /> : '?'))}</ul>
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Form/Errors.js